module.exports = __webpack_public_path__ + "img/bg_pc.268442cf.webp";